import { Button } from "react-bootstrap";
import classRoomImg from "../../../../assets/img/teacherDashboard/Classroom.png";
import "./Lessons.css";
import { useNavigate } from "react-router-dom";
import LessonTable from "./LessonTable";

/**
 * @param {{ type: "Teacher" | "School" }} props
 */
const Lessons = ({ type }) => {
  const navigate = useNavigate();
  return (
    <div className="classroom-cnt">
      <div className="classroom-container">
        <img src={classRoomImg} className="img" alt="Classroom" />
        <h2 className="text">Manage Lesson(s)</h2>
      </div>

      {type !== "School" && (
        <div className="btn-container">
          <Button
            className="primary-btn"
            onClick={() => {
              navigate("/teacher/lesson/create");
            }}
          >
            Create Lesson
          </Button>
        </div>
      )}
      <div>
        <LessonTable type={type} />
      </div>
    </div>
  );
};

export default Lessons;
